module.exports = __webpack_public_path__ + "media/images/riders/small/MAXIME_MAROTTE-4d38f9ead01394e988644626cdaff3e7.png";